import { Injectable } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';
import { WebservicesService } from 'src/app/services/webservices/webservices.service';
import { ConfigService } from '../config/config.service';
import { EventsService } from '../event/event.service';
import { LobbyApiService } from './lobby.api.service';

@Injectable({
  providedIn: 'root',
})

export class KeywordsService {

  private keywordsAndGames: Map<string, any>;

  private lobbiesSubject: Subject<Object[]>;
  private keywordSubject:Subject<string>;
  private hasLiveDealerSubCategory:Subject<boolean>;
  private hasLiveDealerFavPath:Subject<boolean>;
  private liveDealerKeywordInfo:Subject<any>;

  public lobbyList: any;

  constructor(
    private readonly webservicesService: WebservicesService,
    private config:ConfigService,
    private eventsService: EventsService,
    private lobbyApiService: LobbyApiService
    ) {

    this.lobbiesSubject = new ReplaySubject(1);
    this.keywordSubject = new ReplaySubject(1);
    this.hasLiveDealerSubCategory = new ReplaySubject(1);
    this.hasLiveDealerFavPath = new ReplaySubject(1);
    this.liveDealerKeywordInfo = new ReplaySubject(1);
    this.callGetLobbies();

    this.keywordsAndGames = new Map();

    this.eventsService.subscribe("event:config:reload", () => {
      this.callGetLobbies().then(() => {
        this.eventsService.publish('action:reloadLobbies');
      });
    });
  }

  callGetLobbies() {
    return new Promise((resolve, reject) => {
      this.lobbyApiService.fetchLobbiesKeywords().subscribe(
        (resp: any) => {
          if (!!resp.result && resp.payload) {
            this.lobbyList = resp.payload;
            this.setLobbies(this.lobbyList);
            resolve(null);
          }
        }
      );
    });
  }

  setLobbies(payload: any) {
    this.lobbiesSubject.next(payload);
  }

  public getLobbies() {
    return this.lobbiesSubject;
  }

  public getLobbyList(){
    return this.lobbyList;
  }

  setKeyword(payload: string) {
    this.keywordSubject.next(payload);
  }

  setLiveDealerSubCategory(value: boolean) {
    this.hasLiveDealerSubCategory.next(value);
  }
  
  getLiveDealerSubCategory() {
    return this.hasLiveDealerSubCategory;
  }

  setLiveDealerFavPath(value: boolean) {
    this.hasLiveDealerFavPath.next(value);
  }
  
  getLiveDealerFavPath() {
    return this.hasLiveDealerFavPath;
  }

  setLiveDealerKeywordInfo(data: Array<any>){
    let filteredData = data.filter((x)=> x.action_param === 'livedealer' || x.action_param === 'subkeyword');
    this.liveDealerKeywordInfo.next(filteredData[0])
  }

  getLiveDealerKeywordInfo(){
    return this.liveDealerKeywordInfo
  }

  public getKeyword(){
    return this.keywordSubject;
  }

  async getKeywordsAndGames(lobbyName: string, force: boolean = false) {
    if (!force && this.keywordsAndGames.has(lobbyName)) {
      return Promise.resolve(this.keywordsAndGames.get(lobbyName));
    }

    try {
      const data = await Promise.all([this.fetchKeywords(lobbyName), this.fetchGames(lobbyName)]);
      this.keywordsAndGames.set(lobbyName, data);
      return data;
    } catch(e) {
      console.error(e);
    }
  }

  private fetchKeywords(lobbyName) {
    return this.lobbyApiService.fetchKeywords(lobbyName).toPromise();
  }

  private fetchGames(lobbyName) {
    return this.lobbyApiService.fetchGamesByLobbyName(lobbyName).toPromise();
  }

  public getLiveDealerGames() {
    return this.fetchGames("LIVE_DEALER");
  }
}
